module.exports = __webpack_public_path__ + "static/media/molly-greens-wall-sign.6a036478.jpg";